import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from '@fullcalendar/daygrid'
import bootstrap5Plugin from '@fullcalendar/bootstrap5'
import interactionPlugin from '@fullcalendar/interaction'
import timeGridPlugin from '@fullcalendar/timegrid'
import ru from '@fullcalendar/core/locales/ru';
import React, {useEffect, useRef, useState} from "react";
import {setCreateButton, setSearchHandler, setSearchString, setTitle} from "../actions/main";
import {useDispatch, useSelector} from "react-redux";
import {PlaningService} from "../services/PlaningService";
// import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import Loader from "../components/Loader";
import {Image} from "primereact/image";
import {Dialog} from "primereact/dialog";
import {Link, useNavigate} from "react-router-dom";
import {Checkbox} from "primereact/checkbox";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {Calendar} from "primereact/calendar";
import FormGroup from "../components/FormGroup";
import {InputTextarea} from "primereact/inputtextarea";
import {Dropdown} from "primereact/dropdown";
import UserDropdownValueTemplate from "../templates/UserDropdownValueTemplate";
import UserDropdownTemplate from "../templates/UserDropdownTemplate";
import {classNames} from "primereact/utils";
import {UsersService} from "../services/UsersService";
import {useFormik} from "formik";
import {Sidebar} from "primereact/sidebar";
import {InputSwitch} from "primereact/inputswitch";

export default function Planing(props) {

    const dispatch = useDispatch()
    const [events, setEvents] = useState([])
    const [users, setUsers] = useState([])
    const [currentUserId, setCurrentUserId] = useState(false)
    const [startDate, setStartDate] = useState(false)
    const [endDate, setEndDate] = useState(false)
    const [isLoaded, setIsLoaded] = useState(false)
    const [isBirthdaysLoaded, setIsBirthdaysLoaded] = useState(false)
    const [birthdays, setBirthdays] = useState(false)
    const [eventDialogShow, setEventDialogShow] = useState(false)
    const [eventDialog, setEventDialog] = useState(false)
    const [eventEditDialogShow, setEventEditDialogShow] = useState(false)
    const [usersBirthdays, setUsersBirthdays] = useState(false)
    const [clientsBirthdays, setClientsBirthdays] = useState(false)
    const [settingsVisible, setSettingsVisible] = useState(false)
    const [eventEditDialog, setEventEditDialog] = useState(false)
    const calendar = useRef()
    const currentDepartment = useSelector(function (state) {
        return state.currentDepartment
    });
    const navigator = useNavigate()


    const userData = useSelector(function (state) {
        return state.auth.userData
    });

    const getClassesNames = (event) => {
        let classes = ['simple-event']

        if (new Date(event.end ? event.end : event.start).getTime() < new Date().getTime()) {
            classes.push('expired')
        }
        if (event.status) {
            classes.push('complete')
        }
        return classes.join(' ')
    }

    const updateData = (start, end) => {

        setEvents([])
        // let eventsData = []

        if (currentUserId) {
            PlaningService.GetList({filter: {user_id: currentUserId}}).then((response) => {
                let eventsData = []
                if (response && response.items) {
                    response.items.map((el) => {
                        eventsData.push({
                            start: new Date(el.start),
                            end: new Date(el.end),
                            title: el.text,
                            object: el.object_id,
                            detail: el.detail,
                            classNames: getClassesNames(el),
                            boss: el.boss,
                            is_task: true,
                            status: el.status,
                            id: el.id
                        })
                    })

                    let newBirthdays = []
                    if (birthdays) {
                        birthdays.map((el) => {
                            if ((el.is_birthday && (el.user_id && usersBirthdays) || (el.object && clientsBirthdays)) || !el.is_birthday) {
                                newBirthdays.push(el)
                            }
                        })

                        setEvents([...eventsData, ...newBirthdays])
                    }
                    setIsLoaded(true)


                }
            })
        }


    }


    const updateBirthdays = (endedLoad = false) => {
        PlaningService.GetBirthdays({branche_id: currentDepartment}).then((response) => {
            let eventsData = []
            if (response) {
                response.map((el) => {
                    eventsData.push({...el, ...{editable: false, startEditable: false}})
                })
                setBirthdays(eventsData)
                setIsBirthdaysLoaded(true)
                if (endedLoad) {
                    setIsLoaded(true)
                }
            }
        })
    }


    useEffect(() => {
        setIsLoaded(false)
        // eventForm.setFieldValue('user_id', currentUserId)
        updateData()
    }, [clientsBirthdays, usersBirthdays, currentUserId]);

    useEffect(() => {
        if (userData.id) {

            setCurrentUserId(userData.id)
        }
    }, [userData]);

    useEffect(() => {
        dispatch(setSearchString(''))
        dispatch(setSearchHandler(false))
        dispatch(setCreateButton(false))
        dispatch(setTitle(false));
    }, [])
    useEffect(() => {
        if (currentDepartment) {
            setEvents([])
            setIsLoaded(false)
            setIsBirthdaysLoaded(false)
            updateBirthdays()

            UsersService.GetList({
                filter: {
                    user_type: 'worker',
                    status: 1,
                    departmentId: currentDepartment
                },
                fields: 'id,username,position.name,avatar',
                'per-page': 1000,
            }).then((result) => {
                setUsers(result.items)
            })
        }
    }, [currentDepartment])


    const showEvent = (event) => {
        setEventDialog(event.event._def)
        setEventDialogShow(true)
    }

    const dialogFooter = (e) => {
        let eventProps = eventDialog.extendedProps;
        return (
            (eventProps.user_id || eventProps.object || eventProps.is_task) ?
                <div className={'p-t-20 d-flex gap-2 justify-content-start'}>
                    {eventProps.user_id &&

                        <Button label={'Открыть профиль'} onClick={(e) => navigator('/users/' + eventProps.user_id)}
                                icon={'pi pi-eye'} className={'p-button p-component p-button-text'} text={true}/>

                    }
                    {eventProps.object &&
                        <Button label={'Открыть заявку'} onClick={(e) => navigator('/client/' + eventProps.object)}
                                icon={'pi pi-eye'} className={'p-button p-component p-button-text'} text={true}/>
                    }
                    {eventProps.is_task &&
                        <Button label={'Удалить'} className={'p-button-danger p-button-text self-end'} text={true}
                                aria-label={'Удалить'} icon={'pi pi-trash'}/>}
                </div>
                : ''

        )
    }

    const dialogEditFooter = (e) => {
        return (
            <div className={'p-t-20 d-flex gap-2 justify-content-start'}>
                <Button onClick={eventForm.handleSubmit}>Добавить</Button>
            </div>
        )
    }

    const dialogHeader = (e) => {
        return (
            <div className={'p-r-15 d-flex align-items-center'}>
                {eventDialog.extendedProps.user_id ?
                    <>
                        <Image src={'http://yii2.easytickets.pro' + eventDialog.extendedProps.avatar}
                               imageClassName={'img-40 rounded-circle m-r-10'}/>


                        <div className={''}>
                            <div>{eventDialog.title}</div>
                            <div
                                className={'f-12 fw-normal d-flex gap-3 m-t-5'}>
                                <div className={'d-flex gap-2'}>
                                    <i className={'pi pi-home'}></i>
                                    {eventDialog.extendedProps.user_department}
                                </div>

                                {eventDialog.extendedProps.user_position && <>
                                    <div className={'d-flex gap-2'}>
                                        <i className={'pi pi-briefcase'}></i>
                                        {eventDialog.extendedProps.user_position}
                                    </div>
                                </>}
                            </div>
                        </div>
                    </>
                    : <div className={'d-flex flex-column'}>
                        <div>{eventDialog.title}</div>
                        <div
                            className={'f-12 fw-normal d-flex gap-2 m-t-5'}>
                            {eventDialog.extendedProps.contact_department &&
                                <div className={'d-flex gap-2'}>
                                    <i className={'pi pi-home'}></i>
                                    {eventDialog.extendedProps.contact_department}
                                </div>
                            }
                            {eventDialog.extendedProps.contact_type &&
                                <div className={'d-flex gap-2'}>
                                    <i className={'pi pi-users'}></i>
                                    {eventDialog.extendedProps.contact_type}
                                </div>
                            }

                            {eventDialog.extendedProps.object &&
                                <div className={'d-flex gap-2'}>
                                    <i className={'pi pi-hashtag'}></i>
                                    {eventDialog.extendedProps.object}
                                </div>
                            }

                        </div>
                    </div>}

            </div>
        )
    }

    const eventForm = useFormik({
        initialValues: {
            title: '',
            start: '',
            end: '',
            user_id: '',
            allDay: 0,
            text: ''
        },
        validate: (data) => {
            let errors = {}

            if (!data.start) {
                errors.start = 'Укажите дату начала!'
            }
            if (!data.title) {
                errors.title = 'Укажите заголовок события!'
            }

            return errors
        },
        onSubmit: (data) => {

            let planingObject = {
                start: data.start,
                end: data.end ? data.end : null,
                allDay: data.end ? 0 : 1,
                user_id: data.user_id ? data.user_id : userData.id,
                text: data.title,
                detail: data.text
            }

            PlaningService.Create(planingObject).then((result) => {
                updateData(startDate, endDate)
                setEventDialogShow(false)
                setEventEditDialogShow(false)
            })
        }
    })


    const isEventFormFieldInvalid = (name) => !!(eventForm.touched[name] && eventForm.errors[name]);

    const getEventFormErrorMessage = (name) => {
        return isEventFormFieldInvalid(name) ? <small className="p-error">{eventForm.errors[name]}</small> :
            <small className="p-error">&nbsp;</small>;
    };

    let eventProps = eventDialog.extendedProps

    return (
        <div className={''}>

            <Sidebar visible={settingsVisible} position={'right'} onHide={() => setSettingsVisible(false)}>


            </Sidebar>

            <div className={'d-flex align-items-end m-b-20 gap-3 header-after'}>
                <div className="col d-flex gap-5">
                    <label className="d-flex">
                        <InputSwitch checked={usersBirthdays} onChange={(e) => setUsersBirthdays(e.target.value)}/>
                        <span className={'m-l-10'}>Дни рождения сотрудников</span>
                    </label>

                    <label className="d-flex">
                        <InputSwitch checked={clientsBirthdays} onChange={(e) => setClientsBirthdays(e.target.value)}/>
                        <span className={'m-l-10'}>Дни рождения клиентов</span>
                    </label>
                </div>
                <div className="col-auto">
                    <Dropdown filter placeholder={'Мой планинг'}
                              valueTemplate={(row) => UserDropdownValueTemplate(row, 'Мой планинг')}
                              value={currentUserId}
                              onChange={(e) => setCurrentUserId(e.target.value)}
                              itemTemplate={UserDropdownTemplate} options={users.map((user) => {
                        return {
                            label: user.username,
                            value: user.id,
                            avatar: user.avatar,
                            position: user.position.name
                        }
                    })}/>
                </div>
            </div>

            {eventDialog &&
                <Dialog style={{width: '500px', maxWidth: '90%'}} visible={eventDialogShow} header={dialogHeader}
                        onHide={(e) => setEventDialogShow(false)} footer={dialogFooter}>


                    {eventProps.is_task && <div className={''}>
                        <div className="m-t-20">
                            <label>
                                <Checkbox checked={eventProps.status === 1}/>
                                <span className={'m-l-10'}>Выполнено</span>
                            </label>

                        </div>
                    </div>}


                </Dialog>
            }
            {eventEditDialog &&
                <Dialog header={'Добавить событие'} footer={dialogEditFooter} style={{width: '500px', maxWidth: '90%'}}
                        onHide={(e) => setEventEditDialogShow(false)} visible={eventEditDialogShow}>

                    <form onSubmit={eventForm.handleSubmit} className={'p-t-10'}>
                        <FormGroup label={''} error={eventForm.errors.title}>
                            <InputText placeholder={'Введите название события'}
                                       size={'lg'}
                                       value={eventForm.values.title}
                                       onChange={(e) => eventForm.setFieldValue('title', e.target.value)}
                                       className={'block p-inputtext-lg w-100 ' + classNames({'p-invalid': isEventFormFieldInvalid('title')})}
                            />

                        </FormGroup>

                        <div className="row">
                            <div className="col-6">
                                <FormGroup label={'Дата начала'} error={eventForm.errors.start}>
                                    <Calendar showTime
                                              className={'w-100 ' + classNames({'p-invalid': isEventFormFieldInvalid('start')})}
                                              value={eventForm.values.start} maxDate={eventForm.values.end}
                                              onChange={(e) => eventForm.setFieldValue('start', e.value)}/>
                                </FormGroup>
                            </div>
                            <div className="col-6">
                                <FormGroup label={'Дата окончания'}>
                                    <Calendar showTime minDate={eventForm.values.start} className={'w-100'}
                                              value={eventForm.values.end}
                                              onChange={(e) => eventForm.setFieldValue('end', e.value)}/>
                                </FormGroup>
                            </div>
                        </div>

                        <FormGroup label={'Исполнитель'}>
                            <Dropdown filter placeholder={'Мой планинг'}
                                      valueTemplate={(r) => UserDropdownValueTemplate(r, 'Мой планинг')}
                                      value={eventForm.values.user_id}
                                      onChange={(e) => eventForm.setFieldValue('user_id', e.target.value)}
                                      itemTemplate={UserDropdownTemplate} options={users.map((user) => {
                                return {
                                    label: user.username,
                                    value: user.id,
                                    avatar: user.avatar,
                                    position: user.position.name
                                }
                            })}/>
                        </FormGroup>

                        <FormGroup label={'Описание задачи'}>
                            <InputTextarea className={'w-100'} rows={5} value={eventForm.values.text}
                                           onChange={(e) => eventForm.setFieldValue('text', e.target.value)}/>
                        </FormGroup>

                    </form>

                </Dialog>
            }

            {isBirthdaysLoaded &&
                <FullCalendar
                    ref={calendar}
                    plugins={[bootstrap5Plugin, dayGridPlugin, interactionPlugin, timeGridPlugin]}
                    initialView="timeGridWeek"
                    locale={ru}
                    // timeZone={'Europe/Moscow'}
                    eventInteractive={true}
                    events={events}
                    themeSystem={'bootstrap5'}
                    firstDay={1}
                    select={(event) => {

                        setEventEditDialogShow(true)
                        setEventEditDialog(event)
                        eventForm.setValues({...{title: ''}, ...event}, false)
                    }}
                    dayMaxEvents={true}
                    dayMaxEventRows={2}
                    selectable={true}
                    selectMirror={true}

                    weekNumbers={false}
                    slotLabelInterval={"01:00:00"}
                    slotLabelFormat={{
                        hour: 'numeric',
                        minute: '2-digit',
                        omitZeroMinute: false,
                        meridiem: 'short'
                    }}

                    eventContent={(eventInfo) => {

                        return (

                            <div className={'d-flex align-items-center'}>
                                {eventInfo.event._def.extendedProps.avatar &&
                                    <Image imageClassName={'img-20 rounded-circle m-r-5'}
                                           src={'http://yii2.easytickets.pro' + eventInfo.event._def.extendedProps.avatar}/>}

                                {eventInfo.event._def.extendedProps.is_birthday && !eventInfo.event._def.extendedProps.avatar &&
                                    <i className={'pi pi-gift m-r-5'}></i>}

                                <div className="event-info">
                                    {eventInfo.timeText &&
                                        <div className={'event-timeText'}>{eventInfo.timeText}</div>
                                    }
                                    <span className={'event-title'}>{eventInfo.event.title}</span>
                                </div>
                            </div>
                        )

                    }}
                    editable={true}
                    height={window.innerHeight - 158}
                    eventLimit={true} // allow "more" link when too many events

                    slotMinTime={"08:00:00"}
                    slotMaxTime={"21:00:00"}
                    slotDuration={'00:15:00'}
                    customButtons={{
                        settings: {
                            text: 'Настроить',
                            icon: 'gear',
                            click: (e) => {
                                setSettingsVisible(true)
                            }
                        }
                    }}
                    headerToolbar={{
                        start: 'prev,next today',
                        center: 'title',
                        end: 'timeGridDay,timeGridWeek,dayGridMonth'
                    }}
                    eventClick={(event) => {

                        showEvent(event)
                    }}
                    eventChange={(event) => {
                        console.log(event)
                        PlaningService.Update(event.event._def.publicId, {
                            start: new Date(event.event._instance.range.start).valueOf() / 1000,
                            end: new Date(event.event._instance.range.end).valueOf() / 1000
                        }).then((result) => {
                            updateData(startDate, endDate)
                        })
                    }}

                    datesSet={(arg) => {
                        setStartDate(arg.start)
                        setEndDate(arg.end)
                        setIsLoaded(false)
                        updateData(arg.start, arg.end)
                    }}
                />
            }
            {!isLoaded || !isBirthdaysLoaded ? <Loader/> : ''}

        </div>
    )
}